import { render, staticRenderFns } from "./ServerDashboard.vue?vue&type=template&id=60afb597&"
import script from "./ServerDashboard.vue?vue&type=script&lang=js&"
export * from "./ServerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ServerDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports